"use client"

import { useState } from "react"
import { motion } from "framer-motion"
import { Copy, Check } from "lucide-react"

const LyricsResult = ({ lyrics, songInfo }) => {
  const [copied, setCopied] = useState(false)

  const copyToClipboard = () => {
    navigator.clipboard.writeText(lyrics).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <motion.div
      className="mt-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <div className="p-6 bg-indigo-600 text-white">
        <h2 className="text-2xl font-bold">{songInfo.songTitle}</h2>
        <p className="text-indigo-200">by {songInfo.singer}</p>
      </div>
      <div className="p-6 relative">
        <pre className="whitespace-pre-wrap font-serif text-lg leading-relaxed text-gray-800 dark:text-gray-200">
          {lyrics}
        </pre>
        <button
          onClick={copyToClipboard}
          className="absolute top-4 right-4 p-2 bg-indigo-100 dark:bg-gray-700 rounded-full hover:bg-indigo-200 dark:hover:bg-gray-600 transition-colors duration-300"
          title="Copy lyrics"
        >
          {copied ? (
            <Check className="text-green-500" size={20} />
          ) : (
            <Copy className="text-indigo-600 dark:text-indigo-400" size={20} />
          )}
        </button>
      </div>
    </motion.div>
  )
}

export default LyricsResult

